const version = {
  getlist: 'version/getlist',
  add: 'version/add',
  update: 'version/update',
  remove: 'version/remove',
  get: 'version/get',
  getlast: 'version/getlast',
}
export default version
